import { COLLECT_COMPAT } from '@/api/apiModules'
import common from '@/utils/common'
export default {
  viewType: 'form',
  module: COLLECT_COMPAT,
  okAction: 'personalSoftCompatibleUpload',
  formatData(data) {
    data.compatibleList = data.compatibleDesc
    return data
  },
  view: {
    title: '添加【软件】兼容性案例',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '550px',
    content: [
      {
        $id: 'softwareName',
        $type: 'input',
        label: '软件名称',
        rules: [
          {
            notEmpty: '软件名称'
          }
        ]
      },
      {
        $id: 'softwareVersion',
        $type: 'input',
        label: '软件版本号',
        rules: [
          {
            notEmpty: '软件版本号'
          }
        ]
      },
      {
        $id: 'compatibleDesc',
        $type: 'sky-product-os-compat-relate',
        label: '兼容性结论'
        // rules: [
        //   {
        //     notEmpty: '兼容性结论'
        //   }
        // ]
      },
      {
        $id: 'verification',
        $type: 'upload-file',
        label: '兼容性测试文档',
        actions: {
          on: {
            updateValue: 'changeUploadAction'
          }
        },
        rules: [
          { checkFileNameLength: 200 },
          {
            customValidate: {
              validate(validateOther, form, curFormItem) {
                let validator = (rule, val, callback) => {
                  let size = val.size
                  if (size > common.fileSizeMax) {
                    callback(new Error('不能超过最大文件上传30M限制'))
                  } else {
                    callback()
                  }
                }
                return {
                  validator
                }
              }
            }
          },
          {
            suffix: {
              includeSuffixes: ['docx', 'pdf', 'zip'],
              errorMessage: '请选择docx、pdf、zip文件格式的文件进行上传'
            }
          }
        ],
        props: {
          ellipsisMessage: true
        }
      }
    ]
  }
}
